import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';

import { useAuth } from '@shared/v2/components/AuthContext';
import { updateRouteQuery } from '@shared/v2/hooks/useSearchQuery/utils';

import dataLayer from '@/v2/utils/dataLayer';

export const QFF_HASH_COOKIE_KEY = 'QF_VALUE';

export const useSendLoginEvent = () => {
  const { memberDetails } = useAuth();
  const router = useRouter();
  useEffect(() => {
    const hasJustLoggedIn = router.asPath.includes('loginSuccess=1');
    if (memberDetails && hasJustLoggedIn) {
      const qffHash = Cookies.get(QFF_HASH_COOKIE_KEY);

      dataLayer.loginEvent({
        qffHash,
        points: memberDetails.points,
        loginStatus: 'logged in',
      });
      updateRouteQuery({ loginSuccess: undefined });
    }
  }, [memberDetails, router.asPath]);
};

export default useSendLoginEvent;
